export default "__VITE_ASSET__BHa2zp03__"